import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {catchError, fromEvent, map, merge, of, ReplaySubject, take, timeout} from 'rxjs';

@Injectable({providedIn: 'root'})
export class BrndtsService {
  private readonly _brndtsAds$ = new ReplaySubject<any>(1);
  readonly brndtsAds$ = this._brndtsAds$.asObservable();

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  init(apiKey: string, host: string, cssSelector: string) {
    this._initializeAds(apiKey, host, cssSelector);

    const win = this.document.defaultView!;
    merge(
      fromEvent(win, 'brndtsAdsReady').pipe(map(() => (win as any).brndtsAds ?? null)),
      fromEvent(win, 'brndtsAdsError').pipe(map(() => null)),
    )
      .pipe(
        take(1),
        timeout(15000),
        catchError(() => of(null)),
      )
      .subscribe(ads => {
        this._brndtsAds$.next(ads);
      });
  }

  markUnavailable() {
    this._brndtsAds$.next(null);
  }

  private _initializeAds(apiKey: string, host: string, cssSelector: string) {
    const safeApiKey = JSON.stringify(apiKey);
    const safeHost = JSON.stringify(host);
    const safeSelector = JSON.stringify(cssSelector);
    const script = this.document.createElement('script') as HTMLScriptElement;
    script.type = 'module';
    script.textContent = `
      (async () => {
        try {
          const module = await import('https://solutions.brndts.com/stable/index.mjs');
          const BrndtsAds = module.default;
          const ads = new BrndtsAds(${safeSelector}, {
            key: ${safeApiKey},
            auth: {
              host: ${safeHost}
            },
            staticRegionsSelector: ""
          });
          window.brndtsAds = ads;
          window.dispatchEvent(new CustomEvent('brndtsAdsReady'));
        } catch (err) {
          console.error("brndts initialization failed:", err);
          window.dispatchEvent(new CustomEvent('brndtsAdsError', { detail: String(err) }));
        }
      })();
    `;
    this.document.body.insertBefore(script, this.document.body.firstChild);
  }
}
